import React, { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { campaign_item_data } from "../../data/campaign_data";
import Auctions_dropdown from "../../components/dropdown/Auctions_dropdown";
import Social_dropdown from "../../components/dropdown/Social_dropdown";
import Collection_items from "../../components/collectrions/Collection_items";
import Image from "next/image";
import Link from "next/link";
import Meta from "../../components/Meta";
import { campaign_detail_page } from "../../services/landing";
import ProSaleBanner from "../../components/ico-landing/ProSaleBanner";
import { useDispatch, useSelector } from "react-redux";
import { setItemsTabIndex } from "../../redux/counterSlice";
import AvatorComponentPreview from "../../components/campaigns/AvatorComponentPreview";
import Tippy from "@tippyjs/react";
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { successToast } from "../../utils/toast";
import ViewSubCampaigns from "../../components/campaigns/View_sub_campaigns";
import CampaignArts from "../../components/campaigns/CampaignArts";
export const baseURL = `${process.env.NEXT_PUBLIC_BASE_URL}/`;

const CampaignPage = () => {
  const [campaign, setCampaign] = useState({});
  const [data, setData] = useState([]);
  const [campaignDes, setCampaignDes] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [loading, setLoading] = useState(false);
  const contentRef = useRef(null);
  const router = useRouter();
  const { campaignId } = router.query;
  const [expandedImage, setExpandedImage] = useState(null);
  const [profileImgError, setProfileImgError] = useState(false);
  const [bannerImgError, setBannerImgError] = useState(false);

  const dispatch = useDispatch();

  // Dispatch the action to update itemsTabIndex
  const handleClick = () => {
    dispatch(setItemsTabIndex(3));
  };

  // Helper function to normalize social media data between old and new formats
  const normalizeSocialMedia = (campaignDetail, organization) => {
    // New format: campaignDetail.socialMedia exists
    if (campaignDetail?.socialMedia && Object.keys(campaignDetail.socialMedia).length > 0) {
      return {
        instagram: campaignDetail.socialMedia.instagram || '',
        facebook: campaignDetail.socialMedia.facebook || '',
        linkedin: campaignDetail.socialMedia.linkedin || '',
        tiktok: campaignDetail.socialMedia.tiktok || ''
      };
    }
    // Old format fallback: empty object
    return {
      instagram: '',
      facebook: '',
      linkedin: '',
      tiktok: ''
    };
  };

  // Helper function to normalize image URLs
  const normalizeImageUrl = (url) => {
    if (!url) return null;
    
    // Already a full URL
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }
    
    // Already has leading slash (new format)
    if (url.startsWith("/")) {
      return `${process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:5000"}${url}`;
    }
    
    // Old format without leading slash
    return `${process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:5000"}/${url}`;
  };

  // Helper to get profile image with fallback to organization logo
  const getProfileImage = (campaign, organization) => {
    return campaign?.overview?.profileImageUrl || organization?.logoUrl || null;
  };

  useEffect(() => {
    const fetchApi = (myCampaignId) => {
      // getDetails
      if (myCampaignId !== undefined) {
        campaign_detail_page(myCampaignId)
          .then((res) => {
            // Check if API response is successful
            if (!res.success || !res.campaignDetail) {
              console.error("Invalid API response structure");
              setLoading(false);
              return;
            }

            let tempArray = [];
            const inputString = res.campaignDetail.overview?.description || "";
            // Split the string into an array of sentences using the period as the delimiter
            const sentencesArray = inputString.split(".");
            const firstSentence = sentencesArray[0].trim();
            setCampaign(res.campaignDetail);

            // Normalize social media data
            const normalizedSocialMedia = normalizeSocialMedia(res.campaignDetail, res.organization);

            // Use real campaign dates from the database
            const dateString = res.campaignDetail.overview?.startDate || new Date().toISOString();
            const endDateString = res.campaignDetail.overview?.endDate || new Date().toISOString();

            const dateObjectStartDate = new Date(dateString);
            const dateObjectEndDate = new Date(endDateString);

            const options = {
              year: "numeric",
              month: "short",
              day: "numeric",
            };
            const formattedDateStartDate =
              dateObjectStartDate.toLocaleDateString("en-US", options);
            const formattedDateEndDate = dateObjectEndDate.toLocaleDateString(
              "en-US",
              options,
            );

            const newObj = {
              success: res.campaignDetail,
              username: res.username || "Unknown User",
              organization: {
                ...(res.organization || {}),
                socialMedia: normalizedSocialMedia
              },
              assests: res.assets || [],
              donationCount: res.donationCount || 0,
              arts: res.arts || [],
              giftedArts: res.giftedArts || [],
              shortDescription: firstSentence,

              details: [
                {
                  id: "07.2K",
                  detailsNumber:
                    res.campaignDetail.overview?.campaignType || "N/A",
                  detailsText: "Type",
                },

                {
                  id: "22.55",
                  detailsNumber: res.organization?.category || "N/A",
                  detailsText: "Category",
                },

                {
                  id: ".2K",
                  detailsNumber: res.organization?.type || "Individual",
                  detailsText: "Creator Type",
                },
                {
                  id: "20K",
                  detailsNumber: formattedDateStartDate,
                  detailsText: "Start Date",
                },
                {
                  id: "30K",
                  detailsNumber: formattedDateEndDate,
                  detailsText: "End Date",
                },
              ],
            };
            tempArray.push(newObj);
            setData(tempArray[0]);
            setLoading(true);
          })
          .catch((err) => {
            console.log("API Error:", err);
            setLoading(false);
          });
      }
    };

    // Handle router readiness and extract campaignId
    const currentCampaignId = router.query.campaignId;
    if (currentCampaignId && currentCampaignId !== undefined) {
      fetchApi(currentCampaignId);
    }
  }, [router.query.campaignId]);

  useEffect(() => {
    dispatch(setItemsTabIndex(1));
  }, [dispatch]);

  const handleOwnerNameClick = () => {
    const orgId = data.organization?._id;

    if (!orgId) {
      const userId = campaign?.userId || data.success?.userId;
      if (userId) {
        router.push(`/profile/${userId}`);
      }
      return;
    }

    const profileId = data.organization?.userId || orgId;
    router.push(`/profile/${profileId}`);
  };

  const handleReadMoreClick = () => {
    setIsAnimating(true);
    setCampaignDes(!campaignDes);

    // Reset animation state after transition completes
    setTimeout(() => {
      setIsAnimating(false);
    }, 500);
  };

  // Helper function to get campaign status
  const getCampaignStatus = () => {
    if (!campaign?.overview)
      return {
        text: "Unknown",
        color: "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200",
      };

    const now = new Date();
    const endDate = new Date(campaign.overview.endDate);
    const startDate = new Date(campaign.overview.startDate);

    if (now < startDate) {
      return {
        text: "Upcoming",
        color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
      };
    } else if (now > endDate) {
      return {
        text: "Ended",
        color: "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200",
      };
    } else {
      return {
        text: "Active",
        color:
          "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
      };
    }
  };

  const status = getCampaignStatus();

  return (
    <>
      <Meta title={`${campaignId} || Impactoverse | Impact Art Marketplace`} />

      <main className="min-h-screen bg-gray-50 dark:bg-[#0d102d] pt-20">
        {loading && data && data.success ? (
          <div>
            {/* Campaign Header with Image and Info Card */}
            <section className="relative pt-6">
              <div className="container mx-auto px-3 sm:px-4">
                {/* Top Header: Avatar, Title, Category */}
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-center gap-4">
                    {/* Campaign Profile Image */}
                    <div
                      className="w-16 h-16 rounded-full flex-shrink-0 overflow-hidden bg-gray-100 dark:bg-[#1f2937] cursor-pointer hover:opacity-90 transition-opacity"
                      onClick={() => {
                        const profileImg = getProfileImage(campaign, data.organization);
                        if (profileImg) {
                          const fullUrl = normalizeImageUrl(profileImg);
                          setExpandedImage(fullUrl);
                        }
                      }}
                    >
                      {(() => {
                        const profileImg = getProfileImage(campaign, data.organization);
                        if (profileImg && !profileImgError) {
                          return (
                            <Image
                              src={normalizeImageUrl(profileImg)}
                              alt="Campaign profile"
                              width={64}
                              height={64}
                              className="w-full h-full object-cover"
                              onError={() => setProfileImgError(true)}
                            />
                          );
                        }
                        return <div className="w-full h-full bg-gradient-to-br from-accent to-purple-600"></div>;
                      })()}
                    </div>

                    {/* Title and Category */}
                    <div>
                      <div className="flex items-center gap-3 mb-1">
                        <h1 className="text-xl md:text-2xl font-bold text-accent">
                          {campaign?.overview?.campaignName}
                        </h1>
                        {/* Status Badge */}
                        <span className={`px-3 py-1 text-xs font-medium rounded-full ${status.color}`}>
                          {status.text}
                        </span>
                      </div>
                      <p className="text-sm text-gray-500 dark:text-[#c0c2d0]">
                        {data.organization?.category || campaign?.overview?.campaignType || 'Humanitarian Efforts'}
                      </p>
                      {campaign?.overview?.isSubCampaign && campaign?.overview?.superCampaignId && (
                        <Link
                          href={`/campaign/${campaign.overview.superCampaignId}`}
                          className="mt-2 inline-flex items-center gap-1.5 px-3 py-1 text-xs font-medium rounded-full bg-purple-50 text-purple-700 border border-purple-300 hover:bg-purple-100 dark:bg-purple-900/40 dark:text-purple-200 dark:border-purple-700 transition-colors"
                        >
                          <span aria-hidden="true">⤴</span>
                          Part of{" "}
                          <span className="font-semibold">
                            {campaign.overview.superCampaignName || "a super campaign"}
                          </span>
                        </Link>
                      )}
                    </div>
                  </div>

                  {/* Edit Mode Button - only show for campaign owners */}
                  {/* <button className="px-4 py-2 border border-jacarta-300 dark:border-jacarta-600 text-jacarta-700 dark:text-white rounded-lg hover:bg-jacarta-50 dark:hover:bg-jacarta-700 transition-colors text-sm font-medium">
                    Edit Mode
                  </button> */}
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-6">
                  {/* Left: Campaign Image */}
                  <div className="h-[458px]">
                    {data.success?.overview?.bannerImageUrl?.[0] && !bannerImgError ? (
                      <div
                        className="relative h-full w-full cursor-pointer hover:opacity-95 transition-opacity"
                        onClick={() => {
                          const imageUrl = data.success.overview.bannerImageUrl[0];
                          const fullUrl = normalizeImageUrl(imageUrl);
                          setExpandedImage(fullUrl);
                        }}
                      >
                        <Image
                          src={normalizeImageUrl(data.success.overview.bannerImageUrl[0])}
                          alt="campaign image"
                          width={993}
                          height={458}
                          className="rounded-[16px] object-cover w-full h-full"
                          priority
                          onError={() => setBannerImgError(true)}
                        />
                      </div>
                    ) : (
                      <div className="bg-gradient-to-r from-gray-100 to-gray-200 dark:from-[#131740] dark:to-[#1f2937] flex items-center justify-center rounded-[16px] h-full w-full">
                        <div className="text-center">
                          <svg
                            className="mx-auto h-12 w-12 text-jacarta-400 dark:text-jacarta-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                          <p className="mt-2 text-sm text-jacarta-500 dark:text-jacarta-400">
                            Campaign Image
                          </p>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Right: Campaign Info Card */}
                  <div className="h-auto lg:h-[458px] flex">
                    <div className="relative bg-white dark:bg-[#131740] rounded-[20px] border border-gray-200 dark:border-[#1f2937] p-6 w-full flex flex-col justify-between">
                      {/* Share icon — top-right of card */}
                      <div className="absolute top-4 right-4 z-10">
                        <Tippy
                          animation="fade"
                          arrow={false}
                          trigger="click"
                          interactive={true}
                          placement="bottom-end"
                          offset={[0, 8]}
                          appendTo={() => (typeof window !== 'undefined' ? document.body : undefined)}
                          hideOnClick={true}
                          className="tooltip-container"
                          content={
                            <div className="w-56 rounded-xl border border-gray-200 dark:border-[#1f2937] bg-white dark:bg-[#131740] shadow-xl p-2 text-left text-gray-700 dark:text-white">
                              <FacebookShareButton
                                url={typeof window !== 'undefined' ? window.location.href : ''}
                                className="group flex w-full items-center gap-2 rounded-lg px-3 py-2.5 text-sm hover:bg-gray-50 dark:hover:bg-[#1f2937] transition-colors"
                              >
                                <span className="inline-flex h-5 w-5 items-center justify-center">
                                  <svg className="h-4 w-4 text-gray-600 dark:text-gray-300 group-hover:text-accent" viewBox="0 0 512 512" fill="currentColor">
                                    <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
                                  </svg>
                                </span>
                                <span className="group-hover:text-accent">Facebook</span>
                              </FacebookShareButton>
                              <TwitterShareButton
                                url={typeof window !== 'undefined' ? window.location.href : ''}
                                className="group mt-1 flex w-full items-center gap-2 rounded-lg px-3 py-2.5 text-sm hover:bg-gray-50 dark:hover:bg-[#1f2937] transition-colors"
                              >
                                <span className="inline-flex h-5 w-5 items-center justify-center">
                                  <svg className="h-4 w-4 text-gray-600 dark:text-gray-300 group-hover:text-accent" viewBox="0 0 512 512" fill="currentColor">
                                    <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
                                  </svg>
                                </span>
                                <span className="group-hover:text-accent">Twitter</span>
                              </TwitterShareButton>
                              <WhatsappShareButton
                                url={typeof window !== 'undefined' ? window.location.href : ''}
                                title={campaign?.overview?.campaignName || 'Check this out'}
                                separator=" - "
                                className="group mt-1 flex w-full items-center gap-2 rounded-lg px-3 py-2.5 text-sm hover:bg-gray-50 dark:hover:bg-[#1f2937] transition-colors"
                              >
                                <span className="inline-flex h-5 w-5 items-center justify-center">
                                  <svg className="h-4 w-4 text-gray-600 dark:text-gray-300 group-hover:text-accent" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.472-.148-.67.149-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.074-.297-.149-1.255-.463-2.39-1.475-.883-.787-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.496.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.67-.51-.173-.009-.372-.011-.571-.011-.198 0-.521.074-.794.372-.273.297-1.04 1.016-1.04 2.479s1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.718 2.006-1.412.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.032-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.517-5.26c.001-5.45 4.436-9.885 9.888-9.885 2.64 0 5.112 1.03 6.963 2.882a9.825 9.825 0 012.924 6.995c-.003 5.45-4.438 9.884-9.883 9.884M20.52 3.484A11.815 11.815 0 0012.044 0C5.398 0 .16 5.238.157 11.881c-.001 2.096.547 4.142 1.588 5.943L0 24l6.305-1.654a11.87 11.87 0 005.684 1.455h.005c6.644 0 12.04-5.236 12.043-11.879a11.82 11.82 0 00-3.517-8.438" />
                                  </svg>
                                </span>
                                <span className="group-hover:text-accent">WhatsApp</span>
                              </WhatsappShareButton>
                              <EmailShareButton
                                url={typeof window !== 'undefined' ? window.location.href : ''}
                                subject={campaign?.overview?.campaignName || 'Impactoverse Campaign'}
                                body={typeof window !== 'undefined' ? `Have a look at this campaign: ${window.location.href}` : 'Have a look at this campaign'}
                                className="group mt-1 flex w-full items-center gap-2 rounded-lg px-3 py-2.5 text-sm hover:bg-gray-50 dark:hover:bg-[#1f2937] transition-colors"
                              >
                                <span className="inline-flex h-5 w-5 items-center justify-center">
                                  <svg className="h-4 w-4 text-gray-600 dark:text-gray-300 group-hover:text-accent" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                                    <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                                  </svg>
                                </span>
                                <span className="group-hover:text-accent">Email</span>
                              </EmailShareButton>
                              <div className="my-1 border-t border-gray-100 dark:border-[#1f2937]"></div>
                              <button
                                onClick={() => {
                                  if (typeof window !== 'undefined') {
                                    navigator.clipboard.writeText(window.location.href);
                                    successToast("URL has been copied");
                                  }
                                }}
                                className="group flex w-full items-center gap-2 rounded-lg px-3 py-2.5 text-sm hover:bg-gray-50 dark:hover:bg-[#1f2937] transition-colors"
                              >
                                <span className="inline-flex h-5 w-5 items-center justify-center">
                                  <svg className="h-4 w-4 text-gray-600 dark:text-gray-300 group-hover:text-accent" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M18.364 15.536L16.95 14.12l1.414-1.414a5 5 0 1 0-7.071-7.071L9.879 7.05 8.464 5.636 9.88 4.222a7 7 0 0 1 9.9 9.9l-1.415 1.414zm-2.828 2.828l-1.415 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 1 0 7.071 7.071l1.414-1.414 1.415 1.414zm-.708-10.607l1.415 1.415-7.071 7.07-1.415-1.414 7.071-7.07z" />
                                  </svg>
                                </span>
                                <span className="group-hover:text-accent">Copy link</span>
                              </button>
                            </div>
                          }
                        >
                          <button
                            aria-label="Share campaign"
                            className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 dark:bg-[#1f2937] text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-[#2d3748] hover:text-accent dark:hover:text-accent transition-colors"
                          >
                            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
                            </svg>
                          </button>
                        </Tippy>
                      </div>

                      <div className="space-y-6">
                        {/* Amount Raised — USD and POL are shown separately and never summed */}
                        <div>
                          <div className="mb-1 text-xl font-semibold">
                            <span className="text-accent text-2xl">
                              ${(campaign.totalRaised || 0).toLocaleString()}
                            </span>
                            <span className="text-gray-500 dark:text-[#c0c2d0]"> USD raised</span>
                          </div>
                          {(campaign.totalRaisedPol || 0) > 0 && (
                            <div className="mb-1 text-sm font-semibold text-accent">
                              + {(campaign.totalRaisedPol || 0).toLocaleString()} POL raised
                            </div>
                          )}
                          <div className="text-sm text-gray-500 dark:text-[#c0c2d0]">
                            {((data?.arts?.length || 0) + (data?.giftedArts?.length || 0)).toLocaleString()} Impact Art pieces
                          </div>
                        </div>

                        {/* Location */}
                        <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-[#c0c2d0]">
                          <svg className="w-3.5 h-3.5 flex-shrink-0 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          <span>International, {campaign?.overview?.country || 'United States of America'}</span>
                        </div>

                        {/* Action Buttons */}
                        <div className="space-y-2.5">
                          <button
                            onClick={() => router.push(`/dashboard/create-dot?campaignId=${campaignId}`)}
                            className="w-full bg-accent hover:bg-accent-dark text-white py-2.5 px-4 rounded-[10px] font-medium transition-colors text-sm"
                          >
                            Create/Contribute Art
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Organizer Partnership Text */}
                <div className="mt-6 mb-8">
                  <p className="text-sm text-gray-500 dark:text-[#c0c2d0]">
                    <button
                      onClick={handleOwnerNameClick}
                      className="font-medium text-accent hover:text-accent-dark hover:underline transition-colors"
                    >
                      {data.username || campaign?.overview?.campaignName}
                    </button>{" "}
                    is organizing this campaign
                  </p>
                </div>
              </div>
            </section>

            {/* Content Tabs Section */}
            <section id="section1" className="pt-6 pb-6 sm:pb-10">
              <div className="container mx-auto px-3 sm:px-4">
                <div className="bg-white dark:bg-[#131740] rounded-[20px] border border-gray-200 dark:border-[#1f2937] overflow-hidden">
                  <Collection_items
                    description={campaign?.overview?.description}
                    feasibility={campaign?.feasibility}
                    impact={campaign?.impact}
                    campaignDes={campaign?.overview?.description}
                    isSuperCampaign={campaign.overview?.isSuperCampaign}
                    campaignId={campaignId}
                    campaign={campaign}
                    organization={data.organization}
                  />
                </div>
              </div>
            </section>

            {/* Impact art + gifted art tied to this campaign. Off-chain
                pieces already render (buyable) in the "Buy Impact Art" tab
                above from the same campaign — showing them here too listed
                every piece twice on the page, so this section keeps only the
                on-chain rail plus gifts. */}
            <CampaignArts
              arts={(data.arts || []).filter((a) => a.rail === "onchain")}
              giftedArts={data.giftedArts}
            />

            {/* Sub-campaigns Section (only for super campaigns) */}
            {campaign?.overview?.isSuperCampaign && (
              <section className="mt-10">
                <div className="container mx-auto px-3 sm:px-4">
                  <h2 className="text-2xl font-bold mb-4 dark:text-white">Sub-campaigns</h2>
                  <ViewSubCampaigns id={campaign._id} />
                </div>
              </section>
            )}
          </div>
        ) : (
          /* Loading State */
          <div className="container mx-auto px-3 sm:px-4 py-6 sm:py-8">
            <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
              <div className="animate-spin rounded-full h-10 w-10 sm:h-12 sm:w-12 border-b-2 border-accent mb-3 sm:mb-4"></div>
              <p className="text-sm sm:text-base text-gray-500 dark:text-[#c0c2d0] text-center">
                Loading campaign details...
              </p>
            </div>
          </div>
        )}
      </main>
    </>
  );
};

// Local component for animated description section
const DescriptionSection = ({ fullText, shortText }) => {
  const [expanded, setExpanded] = useState(false);
  const [animating, setAnimating] = useState(false);
  const outerRef = useRef(null);
  const innerRef = useRef(null);

  // Compute heights for smooth open/close that pushes layout
  const toggle = () => {
    if (animating) return;
    const outer = outerRef.current;
    const inner = innerRef.current;
    if (!outer || !inner) {
      setExpanded(!expanded);
      return;
    }
    setAnimating(true);
    const startHeight = outer.getBoundingClientRect().height;

    // Temporarily set height to auto to measure target height
    outer.style.height = startHeight + "px";
    outer.style.overflow = "hidden";
    requestAnimationFrame(() => {
      setExpanded((prev) => !prev);
      requestAnimationFrame(() => {
        const targetHeight = inner.getBoundingClientRect().height;
        outer.style.height = targetHeight + "px";
        outer.style.transition = "height 400ms ease";
      });
    });
  };

  // After expansion state change completes, clean inline styles
  const handleTransitionEnd = (e) => {
    if (e.propertyName !== "height") return;
    const outer = outerRef.current;
    if (outer) {
      outer.style.height = "auto";
      outer.style.overflow = "visible";
      outer.style.transition = "";
    }
    // Small timeout to avoid click during layout settle
    setTimeout(() => setAnimating(false), 40);
  };

  // When collapsing, we need to set explicit height then to 0
  useEffect(() => {
    if (!animating) return; // handled in toggle
  }, [animating]);

  // If collapsing (expanded just turned false) run reverse height anim
  useEffect(() => {
    // Collapse path: triggered after expanded state flips in toggle
    // Opening handled in toggle; we need to detect collapse to animate to short height
    if (!animating) return;
  }, [expanded, animating]);

  return (
    <div className="px-2 sm:px-4 md:px-8 lg:px-12">
      <div
        ref={outerRef}
        onTransitionEnd={handleTransitionEnd}
        className="relative"
      >
        <div
          ref={innerRef}
          className="text-sm sm:text-base text-jacarta-600 dark:text-jacarta-300 leading-relaxed space-y-2"
        >
          <p className="whitespace-pre-line">
            {expanded ? fullText : shortText}
          </p>
          <button
            type="button"
            onClick={toggle}
            disabled={animating}
            className="text-accent hover:text-accent-dark font-medium inline-flex items-center gap-1 focus:outline-none"
            aria-expanded={expanded}
          >
            {expanded ? (
              <>
                Read less
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 15l7-7 7 7"
                  />
                </svg>
              </>
            ) : (
              <>
                Read more
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </>
            )}
          </button>
        </div>
      </div>

      {/* Image Modal */}
      {expandedImage && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/90 p-4"
          onClick={() => setExpandedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-accent transition-colors z-[10000]"
            onClick={() => setExpandedImage(null)}
            aria-label="Close"
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div
            className="relative max-w-7xl max-h-[90vh] w-full h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <Image
              src={expandedImage}
              alt="Expanded view"
              width={1920}
              height={1080}
              className="max-w-full max-h-full w-auto h-auto object-contain"
              onError={() => setExpandedImage(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignPage;
